<hw-page-header class="page-header sticky" header="mdm.obs-def-03.header">
  <div class="content float-right"></div>
</hw-page-header>

<nz-content class="page-content">
  <div class="page-content__container container">
    <div nz-col nzSpan="24">
      <hw-form-row>
        <div *hw-form-col>
          <hw-form-item name="definition" label="mdm.obs-def-03.definition">
            <hw-observation-definition-select
              [(ngModel)]="definition"
              (ngModelChange)="selectDefinition($event)"></hw-observation-definition-select>
          </hw-form-item>

          <hw-form-item name="definition" label="mdm.obs-def-03.usage">
            <hw-term-codesystem-concept-select
              [(ngModel)]="usage"
              name="qualifiedIntervalUsage"
              codesystem="observation-interval-usage"
              required></hw-term-codesystem-concept-select>
          </hw-form-item>

          <nz-divider [nzText]="'mdm.obs-def-03.value' | translate" nzOrientation="left" *ngIf="value"></nz-divider>
          <ng-container *ngFor="let def of selectedDefinitions">
            <ng-template #link>
              <a (click)="navigate(['/observation-definitions/edit', def.id])">
                {{
                  (def.names | localName) + (def.defaultUnit ? ' (' + (def.defaultUnit.alias | localName) + ')' : '')
                }}
              </a>
            </ng-template>
            <hw-form-item [name]="def.code" [label]="link">
              <hw-data-input
                *ngIf="def | format : isEditable"
                [(ngModel)]="value[def.code]"
                [dataType]="def?.dataType?.code"
                [options]="def?.dataOptions"
                [multiple]="def?.dataOptions?.multiple"></hw-data-input>
              <span *ngIf="!(def | format : isEditable)">{{ value[def.code] }}</span>
            </hw-form-item>
          </ng-container>

          <nz-divider [nzText]="'mdm.obs-def-03.criteria' | translate" nzOrientation="left"></nz-divider>
          <hw-form-item name="gender" label="mdm.obs-def-03.age">
            <hw-input-number name="age-lower" [(ngModel)]="criteria['age']"></hw-input-number>
          </hw-form-item>

          <hw-form-item name="gender" label="mdm.obs-def-03.gender">
            <hw-term-codesystem-concept-select
              name="gender"
              [(ngModel)]="criteria['gender']"
              codesystem="administrative-gender"></hw-term-codesystem-concept-select>
          </hw-form-item>

          <hw-form-item>
            <button nz-button (click)="calculate()">{{ 'mdm.obs-def-03.match' | translate }}</button>
          </hw-form-item>

          <nz-divider [nzText]="'mdm.obs-def-03.matched-intervals' | translate" nzOrientation="left"></nz-divider>
          <hw-form-item *ngFor="let intval of matchingIntervals">
            <nz-alert [nzMessage]="asd" nzType="info"></nz-alert>
            <ng-template #asd>
              <i
                nz-icon
                [nzType]="'info-circle'"
                [ngStyle]="{ color: this.iconMap[intval.interpretation?.code]?.color }"
                nzTheme="fill"></i>
              {{ intval | json }}
            </ng-template>
          </hw-form-item>
        </div>
      </hw-form-row>
    </div>
  </div>
</nz-content>
